// src/features/todos/TodoDueListener.tsx
import * as React from "react";
import { io } from 'socket.io-client';
import {useStateContext} from "../../hooks/useStateContext";
import {DuePayload, TodoDueDialog} from './TodoDueDialog';
import api from "../../services/api";
import toast from 'react-hot-toast';

export function TodoDueListener() {
  const { user, snoozedTodos, setSnoozedTodos } = useStateContext();
  const [open, setOpen] = React.useState(false);
  const [current, setCurrent] = React.useState<DuePayload | undefined>();
  const seenRef = React.useRef<Set<number>>(new Set());

  const handleOk = async (item:any) => {
    if (!item?.id) { setOpen(false); return; }
    try {
      await api.delete(`/todos/${item.id}`);
      setSnoozedTodos(prev => prev.filter(id => id !== item.id)); // <- kivenni
      toast.success('Todo successfully confirmed');
    } catch (e) {
      toast.error("Failed to confirm todo");
    } finally {
      setOpen(false);
    }
  };

  const handleSnooze = (item:any) => {
    if (item?.id) {
      setSnoozedTodos(prev => (prev.includes(item.id) ? prev : [...prev, item.id]));

      api.post(`/todos/${item.id}/snooze`,{}).then((items: any) => {
      })
        .catch(() => {});

    }
    setOpen(false);
  };

  const handlePass = (item:any) => {
    if (item?.id) {
      api.post(`/todos/${item.id}/pass`,{}).then((items: any) => {
      })
        .catch(() => {});
    }
    setOpen(false);
  };

  React.useEffect(() => {
    if (!user?.id) return;

    const socket = io('https://socket-zoe.stagemporium.com');
    const channel = `users.${user?.id}`;

    const join = () => socket.emit("join", { channel });
    if (socket.connected) join();
    socket.on("connect", join);

    const onDue = (payload: DuePayload) => {
      if (payload.channel && payload.channel !== channel) return;
      if (payload.id && seenRef.current.has(payload.id)) return;
      if (payload.id) seenRef.current.add(payload.id);
      setCurrent(payload);
      setOpen(true);
      if ("Notification" in window && Notification.permission === "granted") {
        new Notification("Esedékes teendő", { body: payload.title || "Új teendő" });
      }
    };

    socket.on("todo.due", onDue);

    api.get("/todos/due-now").then((items: any) => {
        const first = items?.find((x:any) => !seenRef.current.has(x.id));
        if (first) {
          if (first.id) seenRef.current.add(first.id);
          setCurrent(first);
          setOpen(true);
        }
      })
      .catch(() => {});

    const interval = window.setInterval(() => {
      api.get("/todos/due-now")
        .then((items: any) => {
          const next = items?.find((x:any) => !seenRef.current.has(x.id));
          if (next) {
            seenRef.current.add(next.id);
            setCurrent(next);
            setOpen(true);
          }
        })
        .catch(() => {});
    }, 60_000);

    return () => {
      socket.off("todo.due", onDue);
      socket.off("connect", join);
      window.clearInterval(interval);
      socket.emit("leave", { channel });
    };
  }, [user]);

  return (
    <TodoDueDialog
      open={open}
      onSnooze={handleSnooze}
      onPass={(item)=>handlePass(item)}
      onClose={()=>setOpen(false)}
      onConfirm={() => handleOk(current)}
      todo={current}
    />
  );
}
